import type {OrderFormState} from '../../../types'

export const DEFAULT_PAYMENT_INFO = {type: 'cargocorp', kind: 'card'}

export const toPaymentInfo = (formState: OrderFormState) => {
  const paymentInfo = {
    id: formState.payment_info?.method_id,
    type: formState.payment_info?.type,
    kind: formState.payment_info?.kind,
    has_disable_reason: formState.payment_info?.has_disable_reason,
  }
  return paymentInfo.type ? paymentInfo : DEFAULT_PAYMENT_INFO
}
